import React from "react";
import PropTypes from "prop-types";
import "./Button.scss";

const Button = ({
  text,
  onClick,
  type = "primary",
  size = "medium",
  disabled = false,
  icon,
  iconPosition = "right",
  fullWidth = false,
  loading = false,
  className = "",
}) => {
  const buttonClasses = [
    "button",
    `button--${type}`,
    `button--${size}`,
    fullWidth && "button--full-width",
    loading && "button--loading",
    disabled && "button--disabled",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <button
      className={buttonClasses}
      onClick={onClick}
      disabled={disabled || loading}
      type="button"
    >
      {loading ? (
        <span className="button__loader"></span>
      ) : (
        <>
          {icon && iconPosition === "left" && (
            <span className="button__icon button__icon--left">{icon}</span>
          )}
          <span className="button__text">
            {text} {"  "}
          </span>
          {icon && iconPosition === "right" && (
            <span className="button__icon button__icon--right">{icon}</span>
          )}
        </>
      )}
    </button>
  );
};

Button.propTypes = {
  text: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  type: PropTypes.oneOf([
    "primary",
    "secondary",
    "red",
    "success",
    "outline",
    "ghost",
    "link",
  ]),
  size: PropTypes.oneOf(["small", "medium", "large"]),
  disabled: PropTypes.bool,
  icon: PropTypes.node,
  iconPosition: PropTypes.oneOf(["left", "right"]),
  fullWidth: PropTypes.bool,
  loading: PropTypes.bool,
  className: PropTypes.string,
};

export default Button;
